import React from "react";
import omit from "@/utils/omit";

interface ArrowIconProps {
  color?: string;
  width?: number;
  height?: number;
  direction?: "up" | "down" | "left" | "right";
  strokeWidth?: number;
  onClick?: () => void;
}

const rotationMap = {
  right: "0deg",
  down: "90deg",
  left: "180deg",
  up: "270deg",
};

const IconArrow: React.FC<ArrowIconProps> = ({
  color = "#333",
  width = 24,
  height = 24,
  direction = "left",
  strokeWidth = 2,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: `rotate(${rotationMap[direction]})`,
        transition: "transform 0.3s ease",
      }}
      {...omit(props, ["className"])}
      className="yfm-icon yfm-icon-arrow"
    >
      <path
        d="M8 5L15 12L8 19"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
};
IconArrow.displayName = "IconArrow";

export default IconArrow;
